<script>
import { zendeskValidateActions, widgetActions } from '@state/helpers'

export default {
  name: 'PaymentsRt',
  props: {
    componentData: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      inputAmount: '',
      selectedPayment: null,
      OpenIndicator: {
        render: createElement =>
          createElement('span', { class: { toggle: true } }),
      },
      attributes: {
        ref: 'openIndicator',
        role: 'presentation',
        class: 'none',
      },
    }
  },
  computed: {
    computedTitle: function () {
      return 'Selecciona fecha'
    },
  },
  watch: {
    selectedPayment () {
      const { name } = this.$options

      this.inputAmount =
        this.selectedPayment && this.selectedPayment.amount
          ? this.selectedPayment.amount
          : null

      if (!this.selectedPayment) {
        this.commitValidatedField({
          type: 'function',
          key: 'paymentRTValidation',
          name,
          value: this.inputAmount,
          message: this.$t('WIDGETS.PAYMENTS_RT.PAYMENTS_SELECT_WARNING_TOAST'),
        })
        this.commitWidgetChanges({
          widgetName: name,
          data: {
            issuedPayment: null,
          },
        })
      } else if (this.inputAmount < 0) {
        this.commitValidatedField({
          type: 'function',
          key: 'paymentRTValidation',
          name,
          value: this.inputAmount,
          message: this.$t('WIDGETS.PAYMENTS_RT.USER_DEBT', {
            paymentAmount: this.inputAmount,
          }),
        })
        this.commitWidgetChanges({
          widgetName: name,
          data: {
            issuedPayment: null,
          },
        })
      } else if (this.selectedPayment && this.selectedPayment.success) {
        this.commitValidatedField({
          type: 'function',
          key: 'paymentRTValidation',
          name,
          value: this.inputAmount,
          message: this.$t('WIDGETS.PAYMENTS_RT.PAYMENTS_TEXT_TOAST', {
            paymentAmount: this.inputAmount,
          }),
        })
        this.commitWidgetChanges({
          widgetName: name,
          data: {
            issuedPayment: null,
          },
        })
      } else {
        this.commitWidgetChanges({
          widgetName: name,
          data: {
            issuedPayment: this.selectedPayment,
          },
        })
        this.removeValidatedField({ key: 'paymentRTValidation' })
      }
    },
  },
  created () {
    const { name } = this.$options

    this.commitValidatedField({
      type: 'function',
      key: 'paymentRTValidation',
      name,
      value: this.inputAmount,
      message: this.$t('WIDGETS.PAYMENTS_RT.PAYMENTS_SELECT_WARNING_TOAST'),
    })
  },
  methods: {
    ...zendeskValidateActions,
    ...widgetActions,
  },
}
</script>

<template>
  <div class="payments-container">
    <v-select
      :options="componentData.history"
      v-model="selectedPayment"
      :placeholder="$t('WIDGETS.PAYMENTS_RT.DATE_PLACEHOLDER')"
      class="payments-dropbtn"
      label="range"
    >
      <template
        slot="option"
        slot-scope="option"
      >
        <div class="option-item">
          <p>{{ option.range }}</p>

          <input
            :checked="
              selectedPayment ? option.range === selectedPayment.range : false
            "
            class="radio"
            type="radio"
          >
        </div>
      </template>

      <template slot="open-indicator">
        <span v-bind="attributes">
          <BaseIcon name="calendarWeek" />
        </span>
      </template>

      <template
        slot="no-options"
        class="no-payment-option"
      >
        {{ $t('WIDGETS.PAYMENTS_RT.NO_PAYMENTS') }}
      </template>
    </v-select>

    <BaseInput
      v-model="inputAmount"
      :type="componentData.type"
      :name="componentData.name"
      :placeholder="$t('WIDGETS.PAYMENTS_RT.AMOUNT_PLACEHOLDER')"
      :maxlength="componentData.maxlength"
      :disabled="true"
      full
      class="payment-input"
    />

    <p
      v-if="selectedPayment && selectedPayment.success === true"
      class="payment-text"
    >
      {{ $t('WIDGETS.PAYMENTS_RT.PAYMENTS_TEXT_FIRST') }}
      <span>{{ inputAmount }}</span>,
      {{ $t('WIDGETS.PAYMENTS_RT.PAYMENTS_TEXT_LAST') }}
    </p>
    <p
      v-if="selectedPayment && selectedPayment.amount < 0"
      class="payment-text"
    >
      {{ $t('WIDGETS.PAYMENTS_RT.USER_DEBT') }}
    </p>
  </div>
</template>

<style lang="scss">
@import '@design';
@import 'vue-select/src/scss/vue-select.scss';

.payments-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
}

.payments-dropbtn {
  width: 90%;
  margin-bottom: 1rem;
  outline: none;
}

.payment-input {
  @extend %typography-medium;

  width: 100%;
  background-color: #fefefe;
}

.payments-dropbtn .vs__search::placeholder,
.payments-dropbtn .vs__dropdown-toggle,
.payments-dropbtn .vs__dropdown-menu {
  @extend %typography-medium;

  border: $size-input-border solid $divider-gray;
  border-radius: $size-input-border-radius;
  background-color: white;
  padding: 0.4rem;
}

.payments-dropbtn .vs__clear,
.payments-dropbtn .vs__open-indicator {
  fill: #394066;
}

.radio {
  vertical-align: text-top;

  filter: brightness(90%);
  position: relative;
  display: inline-block;
  min-width: 1.5rem;
  height: 1.5rem;
  margin: 0;
  margin-right: -1rem;
  cursor: pointer;
  border: 2px solid #b8b4b4;
  border-radius: 50%;
  -webkit-appearance: none;

  &::after {
    position: relative;
    top: 17%;
    display: block;
    margin: 0 auto;
    width: 0.8rem;
    height: 0.8rem;
    content: '';
    border-radius: 25px;
  }

  &:checked {
    border: 2px solid rgba($color-rt-cian-primary, 0.7);
    &::after {
      background-color: $color-rt-cian-primary;
    }
  }

  &:focus {
    outline: none;
  }
}
.option-item {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;

  & > p {
    margin-left: -1rem;
  }
}

.payment-text {
  @extend %typography-medium;
  text-align: center;
  padding: 1rem;

  span {
    /* @extend %typography-large; */

    filter: brightness(80%);

    color: $color-rt-cian-primary;
    font-weight: bold;
  }
}

.no-payment-option {
  @extend %typography-medium;
  font-style: oblique;
}
</style>
